import React, { useState, useEffect } from "react";
import { ZifData } from "./config";
import {
  NavTree,
  TwoViewer,
  GridViewer,
  NaviGation,
  InfoDiv,
  Thumbnail,
  Z,
  Modal2DLoader,
} from "huakeda-brain-ui";
import './index.css'
import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space, Radio, RadioChangeEvent } from "antd";

const Tast1: React.FC = () => {
  // 当前选择的切面
  const [layer, setLayer] = useState<string>("Sagittal sections");
  const [layerxyz, setLayerxyz] = useState<string>("x");
  // 当前树结构
  const [placement, setPlacement] = useState<string>("nucleusColour");
  // 当前的面
  const [totalLevel, setTotalLevel] = useState<number>(ZifData.Sagittal.count);
  const [currentLevel, setCurrentLevel] = useState<number>(
    Math.floor(ZifData.Sagittal.count / 2)
  );
  // 鼠标位置
  const [mouse, setMouse] = useState([0, 0]);
  // 控制缩略图显示
  const [isListVisible, setListVisible] = useState(false);
  // 控制网格的显示
  const [isGridViewer, setGridViewer] = useState(true);
  const [is3DViewer, set3DViewer] = useState(true);
  // 当前选中的fbx核团
  const [fbxname, setfbxname] = useState("");
  // 当前的悬浮在的核团
  const [hovername,setHovername] = useState("")
  // const [modelLevel,setModelLevel] =useState(0);
  useEffect(() => {
    setTotalLevel(getLayer(layer));
    setCurrentLevel(Math.floor(getLayer(layer) / 2));
  }, [layer]);
  useEffect(() => {
    Z.setDate(setfbxname);
    Z.setname(setHovername)
  }, []);
  
  const getLayer = (layer: string): number => {
    if (layer === "Coronal sections") {
      setLayerxyz("z");
      return ZifData.Coronal.count;
    }
    if (layer === "Sagittal sections") {
      setLayerxyz("x");
      return ZifData.Sagittal.count;
    }
    if (layer === "Horizontal sections") {
      setLayerxyz("y");
      return ZifData.Horizontal.count;
    }
    return 0;
  };
  
  const btnClick = ({ key }: { key: string }) => {
    setLayer(key);
  };

  const placementChange = (e: RadioChangeEvent) => {
    setPlacement(e.target.value);
  };
  return (
    <div style={{position:"relative"}}>
      {/* 3D模型 */}
      <Modal2DLoader
        totalLevel={totalLevel}
        currentLevel={currentLevel}
        setcurrentLevel={setCurrentLevel}
        is3DViewer={false}
        layerxyz={layerxyz}
        is2DViewer={true}
      />
      {/* zif显示猴脑 */}
      <TwoViewer
        data_path='/monkey/'
        layer={layer}
        CurrentLevel={currentLevel}
        isListVisible={isListVisible}
        setListVisible={setListVisible}
        isGridViewer={isGridViewer}
        setGridViewer={setGridViewer}
        is3DViewer={is3DViewer}
        set3DViewer={set3DViewer}
        ZifData={ZifData}
        fbxname={fbxname}
        Z={Z}
        threeview={'/3Dtask'}
        setCurrentLevel={setCurrentLevel}
      />

      {/* 网格 */}
      <GridViewer
      orgX={0.5}
      orgY={0.5}
      ZifData ={ZifData}
        // isGridViewer={isGridViewer}
        setMouse={setMouse}
        // ZifData={ZifData}
        
      />
      <div id="nav_left">
        {/* 切面选择 */}
        {/* <Dropdown menu={{ items, onClick: btnClick }}>
          <Button>
            <Space>
              {layer}
              <DownOutlined rev={undefined} />
            </Space>
          </Button>
        </Dropdown> */}
        <div id="nav_menu"style={{width:"225px"}}>
          {/* 选择树 */}
          {/* <Radio.Group value={placement} onChange={placementChange}>
            <Radio.Button value="nucleusColour">nucleusColour</Radio.Button>
            <Radio.Button value="nucleusColour_swanson">
              nucleusColour_swanson
            </Radio.Button>
          </Radio.Group> */}
          {/* 树结构 */}
          <NavTree
          data_path="/monkey/"
            json={placement}
            layerxyz={layerxyz}
            fbxname={fbxname}
            setfbxname={setfbxname}
            CurrentLevel={currentLevel}
            setCurrentLevel={setCurrentLevel}
            Z={Z}
          />
        </div>
      </div>
      <div id="nav_bottom">
        {/* 详情信息 */}
        <InfoDiv mouse={mouse} hovername={hovername} CurrentLevel={currentLevel} />
        <NaviGation
        data_path="/monkey/"
          CurrentLevel={currentLevel}
          threeview={'/?path=/story/example-task3d--logged-in'}
          TotalLevel={totalLevel}
          setCurrentLevel={setCurrentLevel}
          fbxname={fbxname}
          Z={Z}
        />
      </div>
      <div id="nav_right">
        {/* 缩略图 */}
        <Thumbnail
          data_path={"/monkey/"}
          layerxyz={layerxyz}
          CurrentLevel={currentLevel}
          setCurrentLevel={setCurrentLevel}
          TotalLevel={totalLevel}
          isListVisible={isListVisible}
          setListVisible={setListVisible}
        />
      </div>
    </div>
  );
};

export default Tast1;
